import React, { FC } from 'react';
import styled from 'styled-components';
import { ReactComponent as ShovelLogo } from '../../assets/shovel-logo.svg';
import { RegularText } from '../../utils/typography';
import colors from '../../utils/colors';
import { ENV, LOGOUT } from '../../utils/constants/labels';
import * as routes from '../../utils/constants/routes';
import storage from '../../utils/storage';
import { Layout } from 'antd';
import { useHistory } from 'react-router';
import { removeAccessToken } from '../../api/network';
import { environment } from '../../config/configConstants';

const { Header } = Layout;

type Props = {};

const TopBar: FC<Props> = () => {
  const history = useHistory();

  return (
    <Container>
      <LogoWrapper>
        <ShovelLogo style={{ width: '42px', height: '42px', marginRight: '10px' }} />
        <RegularText color={colors.primaryPurple}>{`${environment} ${ENV}`}</RegularText>
      </LogoWrapper>
      <RegularText
        color={colors.primaryPurple}
        style={{ cursor: 'pointer' }}
        onClick={() => {
          storage.clearSession();
          removeAccessToken();
          history.push(routes.LOGIN);
        }}
      >
        {LOGOUT}
      </RegularText>
    </Container>
  );
};

export default TopBar;

const Container = styled(Header)`
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
`;

const LogoWrapper = styled.a`
  display: flex;
  align-items: center;
`;
